export default __webpack_public_path__ + "static/media/sabah88.77bbf593.png";